import Typography from '@setproduct-ui/core/Typography';
import React, { ComponentProps } from 'react';

export const P = ({ children, large = false, ...rest }: ComponentProps<typeof Typography>) => (
  <Typography color="default" type="body" tagName="p" small={!large} colorStep={80} {...rest}>
    {children}
  </Typography>
);
